<button mat-icon-button color="warn" type="button">
  <mat-icon>delete</mat-icon>
</button>
